import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from '@material-ui/core';
import Checkbox from '../checkbox';
import { useTranslate } from 'react-admin';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        borderBottom: 'solid 5px ' + theme.palette.background.default,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);



const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 600,
    },
    tableCell: {
        width: 50,
        borderBottom: 'solid 5px ' + theme.palette.background.default
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
        color: 'white'
    },
    tableSortLabel: {
        color: theme.palette.common.white,
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    }
}));


function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort, style } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    const translate = useTranslate();
    const headCells = [
        { id: 'id', numeric: false, disablePadding: true, label: translate(`pos.support.id`) },
        { id: 'username', numeric: false, disablePadding: true, label: translate(`pos.support.userName`) },
        { id: 'firstName', numeric: false, disablePadding: false, label: translate(`pos.user.firstname`) },
        { id: 'lastName', numeric: false, disablePadding: false, label: translate(`pos.user.lastname`) },
        { id: 'role', numeric: false, disablePadding: false, label: translate(`pos.user.userRole`) },
        { id: 'email', numeric: false, disablePadding: false, label: translate(`pos.user.email`) },
        { id: '', numeric: false, disablePadding: false, label: translate(`pos.support.assignUnAssign`) },
    ];

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    (
                        <StyledTableCell
                            key={'cell-' + headCell.id}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                className={classes.tableSortLabel}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={classes.visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </StyledTableCell>
                    )
                ))}
            </TableRow>
        </TableHead>
    );
}

function DevicesTable({ readOnly, fullAssign, style, isPaging, hiddenHeader, data, getListDevices, handleOnChangeCheckBox, total }) {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [orderBy, setOrderBy] = useState('username');
    const [order, setOrder] = React.useState('desc');

    const handleChangePage = (event, newPage) => {
        const sort = { field: orderBy, order: order.toUpperCase() };
        const pagination = { page: newPage + 1, perPage: rowsPerPage };
        getListDevices(sort, pagination);
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
        setPage(0);

        const sort = { field: orderBy, order: order.toUpperCase() };
        const pagination = { page: 1, perPage: event.target.value };
        getListDevices(sort, pagination);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        setPage(0);

        const sort = { field: property, order: isAsc ? 'DESC' : 'ASC' };
        const pagination = { page: 1, perPage: rowsPerPage };
        getListDevices(sort, pagination);
    };

    if (!data) return null

    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table size="small" aria-label="sticky table">
                    {
                        !hiddenHeader &&
                        <EnhancedTableHead style={style} classes={classes} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} />
                    }

                    <TableBody>
                        {
                            data.map((item, index) => (
                                style !== 'secondary' ?
                                    (
                                        <TableRow key={'table-row-' + index} >
                                            <TableCell className={classes.tableCell}>{item.id}</TableCell>
                                            <TableCell className={classes.tableCell}>{item.username}</TableCell>
                                            <TableCell className={classes.tableCell}>{item.firstName}</TableCell>
                                            <TableCell className={classes.tableCell}>{item.lastName}</TableCell>
                                            <TableCell className={classes.tableCell}>{item.role.name}</TableCell>
                                            <TableCell className={classes.tableCell}>{item.email}</TableCell>
                                            <TableCell className={classes.tableCell}>
                                                <Checkbox
                                                    disabled={readOnly || (fullAssign && (item.room === null))}
                                                    checked={item.isReceiver === true}
                                                    onChange={handleOnChangeCheckBox(item.id)} color="primary">
                                                </Checkbox>
                                            </TableCell>
                                        </TableRow>
                                    )
                                    :
                                    (
                                        !item.isReceiver && (
                                            <TableRow key={'table-row-secondary' + index} >
                                                <TableCell className={classes.tableCell}>{item.id}</TableCell>
                                                <TableCell className={classes.tableCell}>{item.username}</TableCell>
                                                <TableCell className={classes.tableCell}>{item.firstName}</TableCell>
                                                <TableCell className={classes.tableCell}>{item.lastName}</TableCell>
                                                <TableCell className={classes.tableCell}>{item.role.name}</TableCell>
                                                <TableCell className={classes.tableCell}>{item.email}</TableCell>
                                                <TableCell className={classes.tableCell}>
                                                    <Checkbox
                                                        disabled={readOnly || (fullAssign && (item.room === null))}
                                                        checked={item.isReceiver === true}
                                                        onChange={handleOnChangeCheckBox(item.id)} color="primary">
                                                    </Checkbox>
                                                </TableCell>
                                            </TableRow>
                                        )

                                    )

                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {isPaging && <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={total}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />}

        </Paper>
    );
}

export default DevicesTable;
